import API from "../api";
export default {
  namespaced: true,
  state: {
    profiles: { total_count: 0, items: [] }
  },
  mutations: {
    setProfiles(state, data) {
      state.profiles = data;
    }
  },
  actions: {
    async requestProfileSuggestion() {
      const { data } = await API.getProfileSuggestion();
      return data;
    },
    async requestStructureSuggestion() {
      const { data } = await API.getStructureSuggestion();
      return data;
    },
    async requestProfileList({ commit }, payload) {
      const { data } = await API.getProfileList(payload);
      commit("setProfiles", data);
      return data;
    },
    async requestProfile(context, { profileId }) {
      const { data } = await API.getProfile(profileId);
      return data;
    },
    async editProfile(context, { profileId, payload }) {
      const { data } = await API.putProfile({ profileId, payload });
      return data;
    },
    async createProfile(context, payload) {
      const { data } = await API.postProfile(payload);
      return data;
    },
    async requestModuleList() {
      const { data } = await API.getModuleList();
      return data;
    }
  },
  modules: {}
};
